<!--
   Created by Terence on 2024/6/23 - 15:24
-->
<template>
  <div class="content">
    <div class="content-title">图文详情</div>
    <div
      class="content-txt"
      v-html="formattedDescription"
      @click="handleLinkClick"
    ></div>
    <div class="content-imgs">
      <img
        v-for="(item, index) in ltInfo?.detailImages"
        :key="index"
        :src="item + '!lfit_w1080_h1080_png'"
        alt=""
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, inject, computed, onUnmounted } from "vue";
import ArrowRight from "@/components/ArrowRight/index.vue";
import jb from "@frontend/effuse";

const ltInfo = inject("ltInfo");

const formattedDescription = computed(() => {
  const text = ltInfo.value?.description || "";
  // 匹配 https://events.linjieapp.com 开头的 URL
  const urlRegex = /(https:\/\/events\.linjieapp\.com[^\s]*)/g;
  return text.replace(
    urlRegex,
    '<a href="$1" class="link-text" data-url="$1">$1</a>'
  );
});

const handleLinkClick = (e) => {
  const target = e.target;
  if (target.tagName === "A" && target.dataset.url) {
    e.preventDefault();
    const url = target.dataset.url;
    const encodedUrl = encodeURIComponent(url);
    if (window.isInFlutter) {
      jb.navigateTo({
        url: `congress://hybrid?url=${encodedUrl}`,
      });
    } else {
      window.open(url);
    }
  }
};

onMounted(() => {
  console.log(1);
});
</script>

<style lang="scss" scoped>
.content {
  &-title {
    margin: 8rpx 0;
    color: #000;
    font-size: 28rpx;
    font-style: normal;
    font-weight: 500;
    line-height: 44rpx; /* 157.143% */
  }
  &-txt {
    white-space: pre-line;
    color: #000;
    font-size: 28rpx;
    font-style: normal;
    font-weight: 400;
    line-height: 44rpx; /* 157.143% */

    :deep(.link-text) {
      color: #1677ff;
      text-decoration: none;
      word-break: break-all;
    }
  }
  &-imgs {
    img {
      margin-top: 16rpx;
      display: block;
      width: 100%;
    }
  }
}
</style>
